import { F360Product, type IF360Sidebar } from "@/core/@types/types";
import { Router, type RouteRecordRaw } from "vue-router";
import { financasBaseUrl } from "@/core/services/protocols";

export default function useF360Router(router?: Router) {
  const financasNavigation = (screen: string) =>
    window.location.replace(`${financasBaseUrl}/${screen}`);

  const handlePrefixName = (prefix: F360Product | string, router: string) =>
    `${prefix}-${router}`;

  const handleChildren = (
    children: Array<RouteRecordRaw> | undefined,
    prefix: F360Product | string
  ): Array<RouteRecordRaw> => {
    if (!children) return [];

    return children.map((child) => ({
      ...child,
      name: handlePrefixName(prefix, child.name?.toString() || ""),
      children: handleChildren(child.children, prefix)
    }));
  };

  const handleRouterPrefixName = (
    routes: Array<RouteRecordRaw>,
    prefix: F360Product | string
  ): Array<RouteRecordRaw> => {
    return routes.map((route) => ({
      ...route,
      name: handlePrefixName(prefix, route.name as string),
      children: handleChildren(route.children, prefix)
    }));
  };

  const anotherProduct = (product: F360Product | undefined) =>
    product !== F360Product.Financas;

  const handleNavigationToAnotherProduct = (
    product: F360Product | undefined
  ): string | undefined => {
    if (!product) return undefined;

    const anotherProducts: Partial<Record<F360Product, string>> = {
      [F360Product.Financas]: financasBaseUrl
    };

    const url = anotherProducts[product];

    return url;
  };

  const handleRedirectProduct = async (item: IF360Sidebar | undefined) => {
    const productIsnotExists = !item?.product;

    if (productIsnotExists) {
      router?.push({ name: item?.page });

      return;
    }

    const isNotFinancas = anotherProduct(item.product);

    if (isNotFinancas) {
      router?.push({ name: item.page });

      return;
    }

    const url = `${handleNavigationToAnotherProduct(item.product)}/${
      item.page || ""
    }`;
    window.location.replace(url);
  };

  return {
    handleRouterPrefixName,
    handlePrefixName,
    handleRedirectProduct,
    financasNavigation
  };
}
